/**
 * Google Maps deep links (owner, 2026-09-07): wherever the address appears it
 * should offer DIRECTIONS FROM THE VISITOR'S CURRENT LOCATION, not just the
 * place page. The universal-link `dir` API with no origin makes Google use
 * the device's location — and it is a link the visitor chooses to click, so
 * the D48 rule (nothing contacts Google before a deliberate act) holds.
 */
export const directionsUrl = (address: string): string =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

/** the clinic's address, in the form Google resolves most reliably */
export const fullAddress = (parts: {
  addressStreet?: string;
  addressLocality?: string;
  addressPostalCode?: string;
}): string =>
  [parts.addressStreet, [parts.addressLocality, parts.addressPostalCode].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");
